import type { QuickSwitcherHandlerResponseBody } from '@ps/isp-web-services-types';

import { defaultState } from '.';
import type { QuickSwitcherState } from './types';

export const reducers = {
  'cms/update': () => defaultState,
  loading: (state: QuickSwitcherState, payload = true): QuickSwitcherState => ({
    ...state,
    isLoading: payload
  }),
  dataLoadSuccess: (
    state: QuickSwitcherState,
    payload: QuickSwitcherHandlerResponseBody
  ): QuickSwitcherState => ({
    ...state,
    isLoading: false,
    data: payload
  }),
  navigating: (state: QuickSwitcherState, payload: boolean): QuickSwitcherState => ({
    ...state,
    isNavigating: payload
  })
};
